// Códigos dos 403 de plano enviados pela API. Sem dependências: o cliente HTTP (services/api.ts) usa
// este módulo, e lib/plan.ts depende dos serviços.

/** Funcionalidade exclusiva do Pro (ProPlanPolicy.ForbiddenCode no backend, ADR-001). */
export const PRO_PLAN_REQUIRED = "PRO_PLAN_REQUIRED"

/** Limite de quantidade do Free atingido (PlanLimits.ReachedCode no backend, ADR-009). */
export const PLAN_LIMIT_REACHED = "PLAN_LIMIT_REACHED"

export function isProPlanRequired(data: unknown): boolean {
  return (data as { code?: unknown } | null)?.code === PRO_PLAN_REQUIRED
}

/** Carteira somente leitura: leitor ou conjunta sem plano de grupo do titular (WalletReadOnlyException, ADR-021). */
export const WALLET_READ_ONLY = "WALLET_READ_ONLY"

export function isWalletReadOnly(data: unknown): boolean {
  return (data as { code?: unknown } | null)?.code === WALLET_READ_ONLY
}
